export enum CriteriaOperator {
  Equals = 0,
  NotEquals = 1,
  Contains = 2,
  ContainsAnyOf = 3,
  DoesNotContainsAnyOf = 4,
  DoesNotContain = 5,
  MoreThan = 6,
  LessThan = 7,
  IsEmpty = 8,
  IsNotEmpty = 9,
  StartsWith = 10,
  EndsWith = 11,
  Any = 12,
  NotAny = 13,
}
